/** 显示子区及od线 */
import { AppModule } from "@/store/modules/app";
import { loadModules } from "esri-loader";
import { panoramaViewConfig } from "./PanoramaViewConfig";

export default class PanoramaView {
  private static intances: Map<string, PanoramaView>;

  public static getInstance(view: __esri.SceneView) {
    const id = view.container.id;
    if (!PanoramaView.intances) {
      PanoramaView.intances = new Map();
    }
    let instance = PanoramaView.intances.get(id);
    if (!instance) {
      instance = new PanoramaView(view);
      PanoramaView.intances.set(id, instance);
    }
    return instance;
  }

  private view!: __esri.SceneView;

  private FeatureLayer!: __esri.FeatureLayerConstructor;
  private GraphicLayer!: __esri.GraphicsLayerConstructor;

  private areaLayer!: __esri.GraphicsLayer;
  // private fx3dLayer!: Fx3dLayer;

  private nearbyGraphics: Array<__esri.Graphic> = [];
  private addGraphics: Array<__esri.Graphic> = [];
  private maxCount = 0;

  private constructor(view: __esri.SceneView) {
    this.view = view;
  }

  public async initialize() {
    type MapModules = [
      typeof import("esri/layers/GraphicsLayer"),
      typeof import("esri/layers/FeatureLayer")
    ];
    const [GraphicsLayer, FeatureLayer] = await (loadModules([
      "esri/layers/GraphicsLayer",
      "esri/layers/FeatureLayer",
    ]) as Promise<MapModules>);
    this.GraphicLayer = GraphicsLayer;
    this.FeatureLayer = FeatureLayer;

    // this.fx3dLayer = Fx3dLayer.getInstance(this.view);
    // await this.fx3dLayer.initialize();
  }

  public async showPanorama(id: string) {
    for (const config of panoramaViewConfig) {
      if (config.id === id) {
        await this.showNearbyArea();
        // this.fx3dLayer.addLayer({
        //   url: `http://${AppModule.appConfig.gisServer}/arcgis/rest/services/Unicron/NearbyArea/MapServer/3`,
        // });
        break;
      }
    }
  }

  public hidePanorama() {
    // this.fx3dLayer.hideLayer();
    this.areaLayer.removeMany(this.addGraphics);
    this.areaLayer.visible = false;
  }

  public toggleFxLayer() {
    // this.fx3dLayer.toggleFxLayer();
  }

  private async showNearbyArea() {
    if (!this.areaLayer) {
      this.areaLayer = new this.GraphicLayer();
      this.view.map.add(this.areaLayer);

      // await this.animateNearbyArea();
      const areaSourceLayer = new this.FeatureLayer({
        url: `http://${AppModule.appConfig.gisServer}/arcgis/rest/services/Unicron/NearbyArea/MapServer/4`,
        outFields: ["*"],
      });
      const areaGraphics = (
        await areaSourceLayer.queryFeatures(areaSourceLayer.createQuery())
      ).features;

      areaGraphics.forEach((graphic) => {
        graphic.symbol = {
          type: "simple-fill",
          color: this.getAreaColor(graphic.attributes["FEATURENAME"], 0.2),
          outline: {
            color: this.getAreaColor(graphic.attributes["FEATURENAME"]),
            width: 2,
          },
        } as any;
      });
      this.areaLayer.addMany(areaGraphics);

      // 区域中心点图层
      // 文字标注颜色不同，所以新建graphic，不直接显示featurelayer
      const labelSourceLayer = new this.FeatureLayer({
        url: `http://${AppModule.appConfig.gisServer}/arcgis/rest/services/Unicron/NearbyArea/MapServer/2`,
        outFields: ["*"],
      });
      const areaCenterGraphics = (
        await labelSourceLayer.queryFeatures(labelSourceLayer.createQuery())
      ).features;
      areaCenterGraphics.forEach((graphic) => {
        graphic.symbol = {
          type: "text",
          color: this.getAreaColor(graphic.attributes["FEATURENAME"], 1),
          text: graphic.attributes["FEATURENAME"],
          font: {
            family: "微软雅黑",
            size: 14,
            weight: "bold",
          },
        } as any;
      });
      this.areaLayer.addMany(areaCenterGraphics);

      // 显示试验区域
      const testAreaSourceLayer = new this.FeatureLayer({
        url: `http://${AppModule.appConfig.gisServer}/arcgis/rest/services/Unicron/NearbyArea/MapServer/1`,
      });
      const testAreaGraphic = (
        await testAreaSourceLayer.queryFeatures(
          testAreaSourceLayer.createQuery()
        )
      ).features[0];
      testAreaGraphic.symbol = {
        type: "simple-fill",
        color: [57, 168, 255, 0.6],
      } as any;
      this.areaLayer.add(testAreaGraphic);
    } else {
      this.areaLayer.visible = true;
      // await this.animateNearbyArea();
    }
  }

  private animateNearbyArea(): Promise<void> {
    return new Promise((resolve) => {
      let currentHeight = 0;

      requestAnimationFrame(() => {
        frameAnimation();
      });
      const frameAnimation = () => {
        this.areaLayer.removeMany(this.addGraphics);

        this.addGraphics = this.nearbyGraphics.map((graphic) => {
          const addGraphic = graphic.clone();
          const symbol = this.getAreaSymbol(
            addGraphic.attributes["FEATURENAME"],
            Math.min(currentHeight, addGraphic.attributes["Count"])
          );
          addGraphic.symbol = symbol;

          return addGraphic;
        });

        this.areaLayer.addMany(this.addGraphics);

        currentHeight += 5;
        if (currentHeight < this.maxCount) {
          requestAnimationFrame(() => {
            frameAnimation();
          });
        } else {
          resolve();
        }
      };
    });
  }

  private getAreaColor(areaName: string, alpha: number = 1) {
    let color: Array<number> = [];
    switch (areaName) {
      case "徐汇":
      case "普陀":
      case "杨浦":
        color = [57, 168, 255, alpha];
        break;

      case "浦东":
      case "静安":
        color = [157, 172, 255, alpha];
        break;

      case "虹口":
      case "长宁":
        color = [0, 255, 255, alpha];
        break;

      case "闵行":
      case "黄埔":
        color = [98, 255, 76, alpha];
        break;
    }
    return color;
  }

  private getAreaSymbol(
    areaName: string,
    size: number = 0
  ): __esri.PolygonSymbol3D {
    return {
      type: "polygon-3d",
      symbolLayers: [
        {
          type: "extrude",
          size,
          material: { color: this.getAreaColor(areaName, 0.2) },
          edges: {
            type: "solid",
            color: this.getAreaColor(areaName, 0.4),
            size: "4px",
          },
        },
      ],
    } as any;
  }
}
